import React from 'react';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
export const PipedgasIcon = (props) => {
    const { serviceID, value } = props;
    const classes = commonStyle();
    let colorNonSelected = classes.svg_non_selected;
    let colorSelected = classes.svg_selected;
    if (serviceID !== value) {
        colorSelected = classes.svg_non_selected;
    }

    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style={{ enableBackground: 'new 0 0 512 512' }}
        >
            <path
                className={colorNonSelected}
                d="M355.5,510.2H154.3c-7.1,0-12.9-5.5-12.9-12.2v-36.6c-21.4-11.3-35.1-33.9-35.1-58.3V183
	c0-17.2,6.7-33.5,18.8-45.9c11.1-11.3,25.5-18.2,41.1-19.7V72.6H155c-6.8,0-12.6-5.9-12.6-13V12.2C142.4,5.3,148,0,155,0h199.7
	c7.2,0,13.1,5.5,13.1,12.2v47.6v0.1c-0.3,7-5.8,12.5-12.9,12.8h-0.2H344v44.8c15.7,1.4,30.2,8.3,41.2,19.7
	c12,12.4,18.7,28.7,18.7,45.9v220.3c0,24.8-14.1,47.5-36.1,58.5V498c0.1,3.4-1.2,6.6-3.6,8.9c-2.3,2.2-5.2,3.3-8.3,3.3
	C355.9,510.2,355.6,510.2,355.5,510.2z M342.7,485.1v-16.3c-1.7,0.1-3.3,0.2-5,0.2H172.2c-0.6,0-1.1,0-1.7,0c-1.3,0-2.6,0-3.9-0.1
	v16.3h176.1V485.1z M378.8,315.8v-57.4 M378.7,233.3V183c0-22.7-18.3-41.2-40.7-41.2H172.1c-22.4,0-40.7,18.5-40.7,41.2v50.3v25.1
	v57.4V341v62.3c0,22.4,18.3,40.6,40.7,40.6h165.6c22.7,0,41.1-18.3,41.1-40.7V341 M289.4,116.6H319v-44H191.3v44h29.6 M246,116.6
	h18.2 M342.7,47.5V25.1H167.6v22.3L342.7,47.5L342.7,47.5z"
            />
            <circle className={colorSelected} cx="253.1" cy="386.5" r="32.5" />
        </svg>
    );
};
